import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/images/ordr-chartreuse-logo.svg";
import bg from "../../Assets/images/auth-bg.svg";
import "./Auth.scss";

// Matches ordrx_frontend's Signin/Signup: dimmed full-bleed photo, logo bar on top,
// a narrow form centered over it.
export default function AuthLayout({ heading, subheading, children }) {
	return (
		<div className="auth-screen">
			<div className="auth-bg" style={{ backgroundImage: `url(${bg})` }} />
			<header className="auth-header">
				<Link to="/login" className="auth-logo">
					<img src={logo} alt="Ordr" />
					<div className="company-name">
						<span>Buyer</span>
						<span>Central</span>
					</div>
				</Link>
			</header>
			<div className="auth-body">
				<div className="auth-form-box">
					<h2 className="auth-heading">{heading}</h2>
					{subheading ? <div className="auth-subheading">{subheading}</div> : null}
					{children}
				</div>
			</div>
			<footer className="auth-footer">
				ORDR is a registered trademark of PMORDR, Inc. ©{new Date().getFullYear()} PMORDR, Inc.
			</footer>
		</div>
	);
}
